import behave from "./helpers/behave";

behave('.tabs', element => {
    const pills = Array.from(element.querySelectorAll('.pill'))
    const tabs = Array.from(element.querySelectorAll('.tab'))

    let activePill = pills.find(pill => pill.classList.contains('pill--active'))
    let activeTab = tabs.find(tab => tab.classList.contains('tab--active'))

    pills.forEach(
        (pill, index) => {
            pill.addEventListener('click', () => {
                activePill.classList.remove('pill--active')
                pill.classList.add('pill--active')
                activePill = pill

                activeTab.classList.remove('tab--active')
                activeTab = tabs[index]
                activeTab.classList.add('tab--active')
            })
        }
    )
})
